(function () {
  var defaults = {
    blogUrl: '/blogs/recipes',
    dataId: 'fe-recipe-search-data',
    inputId: 'fe-recipe-search-input',
    statusId: 'fe-recipe-search-status',
    filterId: 'fe-recipe-filter',
    wrapSelector: '.fe-recipe-filter-wrap',
    gridId: 'fe-recipe-grid',
    emptyNoun: 'recipes',
    browseLabel: 'Browse all recipes'
  };

  var cfg = defaults;
  var originalGrid = null;

  function getQuery() {
    return new URLSearchParams(window.location.search).get('q') || '';
  }

  var SORTS = {
    newest: true,
    oldest: true,
    'most-rated': true,
    highest: true
  };

  function getSort() {
    var value = new URLSearchParams(window.location.search).get('sort');
    return SORTS[value] ? value : 'newest';
  }

  function writeSortParam(url, sort) {
    if (sort && sort !== 'newest') {
      url.searchParams.set('sort', sort);
    } else {
      url.searchParams.delete('sort');
    }
  }

  function ratingCount(entry) {
    var count = Number(entry && entry.rating_count);
    return isFinite(count) ? count : 0;
  }

  function ratingValue(entry) {
    var rating = Number(entry && entry.rating);
    return isFinite(rating) ? rating : 0;
  }

  function hasRealRating(entry) {
    return ratingCount(entry) > 1;
  }

  function readConfig(form) {
    var searchInput = form.querySelector('[type="search"]');

    return {
      blogUrl: form.getAttribute('data-blog-url') || defaults.blogUrl,
      dataId: form.getAttribute('data-search-data') || defaults.dataId,
      inputId: form.getAttribute('data-search-input') || (searchInput && searchInput.id) || defaults.inputId,
      statusId: form.getAttribute('data-search-status') || defaults.statusId,
      filterId: form.getAttribute('data-filter-id') || defaults.filterId,
      wrapSelector: form.getAttribute('data-filter-wrap') || defaults.wrapSelector,
      gridId: form.getAttribute('data-grid-id') || defaults.gridId,
      emptyNoun: form.getAttribute('data-empty-noun') || defaults.emptyNoun,
      browseLabel: form.getAttribute('data-browse-label') || defaults.browseLabel
    };
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function tagHandle(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function currentTagHandle() {
    var match = window.location.pathname.match(/\/tagged\/([^/?#]+)/);
    return match ? tagHandle(decodeURIComponent(match[1])) : '';
  }

  function getEntries() {
    var dataEl = document.getElementById(cfg.dataId);
    if (!dataEl) return [];
    try {
      return JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
      return [];
    }
  }

  function matches(entry, query) {
    var q = normalize(query);
    if (!q) return false;
    var haystack = normalize(
      [entry.title, entry.excerpt, (entry.tags || []).join(' ')].join(' ')
    );
    return haystack.indexOf(q) !== -1;
  }

  function filterByCurrentTag(entries) {
    var handle = currentTagHandle();
    if (!handle) return entries.slice();
    return entries.filter(function (entry) {
      return (entry.tags || []).some(function (tag) {
        return tagHandle(tag) === handle;
      });
    });
  }

  function sortEntries(entries, sort) {
    return entries.slice().sort(function (a, b) {
      var da = a.published_at || '';
      var db = b.published_at || '';
      var dateNewest = db < da ? -1 : db > da ? 1 : 0;
      var ca = ratingCount(a);
      var cb = ratingCount(b);
      var ra = ratingValue(a);
      var rb = ratingValue(b);

      if (sort === 'oldest') return da < db ? -1 : da > db ? 1 : 0;

      if (sort === 'most-rated') {
        if (cb !== ca) return cb - ca;
        if (rb !== ra) return rb - ra;
        return dateNewest;
      }

      if (sort === 'highest') {
        var realA = hasRealRating(a);
        var realB = hasRealRating(b);
        if (realA !== realB) return realA ? -1 : 1;
        if (rb !== ra) return rb - ra;
        if (cb !== ca) return cb - ca;
        return dateNewest;
      }

      return dateNewest;
    });
  }

  function cardHtml(entry) {
    var image = entry.image
      ? '<div class="blog-post-card__image-container">' +
        '<a href="' +
        escapeHtml(entry.url) +
        '">' +
        '<img class="blog-post-card__image blog-post-card__image--large" src="' +
        escapeHtml(entry.image) +
        '" alt="' +
        escapeHtml(entry.image_alt || entry.title) +
        '" loading="lazy" width="1200" height="800">' +
        '</a></div>'
      : '';

    var excerpt = entry.excerpt
      ? '<div class="blog-post-card__content-text rte">' +
        escapeHtml(entry.excerpt) +
        ' <a href="' +
        escapeHtml(entry.url) +
        '">Read more...</a></div>'
      : '';

    var ratingLine = '';
    if (hasRealRating(entry)) {
      ratingLine =
        '<p class="fe-recipe-card-rating">' +
        escapeHtml(ratingValue(entry).toFixed(1)) +
        ' ★ · ' +
        ratingCount(entry) +
        ' ratings</p>';
    }

    return (
      '<div class="blog-post-item">' +
      '<div class="blog-post-card" style="--text-align: left">' +
      image +
      '<div class="blog-post-card__content">' +
      '<a href="' +
      escapeHtml(entry.url) +
      '"><h3 class="blog-post-card__title">' +
      escapeHtml(entry.title) +
      '</h3></a>' +
      ratingLine +
      excerpt +
      '</div></div></div>'
    );
  }

  function setSearchMode(isSearching) {
    var filter = document.getElementById(cfg.filterId);
    var wrap = document.querySelector(cfg.wrapSelector);
    if (filter) filter.hidden = !!isSearching;
    if (wrap) wrap.classList.toggle('is-searching', !!isSearching);
  }

  function cacheGrid(grid) {
    if (!originalGrid && grid && !grid.classList.contains('fe-recipe-search-results')) {
      originalGrid = {
        html: grid.innerHTML,
        lastPage: grid.getAttribute('data-last-page') || ''
      };
    }
  }

  function queryString(url) {
    var qs = url.searchParams.toString();
    return qs ? '?' + qs : '';
  }

  function setSortUrl(sort) {
    try {
      var url = new URL(window.location.href);
      writeSortParam(url, sort);
      window.history.replaceState({}, '', url.pathname + queryString(url));
    } catch (e) {}
  }

  function syncSortControl(sort) {
    var select = document.querySelector('[data-fe-recipe-sort-select]');
    if (select && select.value !== sort) select.value = sort;
  }

  function syncFilterLinks(sort) {
    var filter = document.getElementById(cfg.filterId);
    if (!filter) return;

    filter.querySelectorAll('a.fe-filter-tab').forEach(function (link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        writeSortParam(url, sort);
        link.setAttribute('href', url.pathname + queryString(url));
      } catch (e) {}
    });
  }

  function markSortReady() {
    document.documentElement.classList.remove('fe-recipe-sort-pending');
    document.documentElement.classList.add('fe-recipe-sort-ready');
  }

  function applyStandaloneSort() {
    var sortRoot = document.querySelector('[data-fe-recipe-sort]');
    var grid = document.getElementById(cfg.gridId);
    var sort = getSort();

    syncSortControl(sort);
    syncFilterLinks(sort);

    if (!sortRoot || !grid || grid.classList.contains('fe-recipe-search-results') && getQuery()) {
      markSortReady();
      return;
    }

    cacheGrid(grid);

    if (sort === 'newest') {
      if (originalGrid) {
        grid.innerHTML = originalGrid.html;
        if (originalGrid.lastPage) grid.setAttribute('data-last-page', originalGrid.lastPage);
        grid.classList.remove('fe-recipe-search-results');
      }
      markSortReady();
      return;
    }

    var entries = sortEntries(filterByCurrentTag(getEntries()), sort);
    grid.classList.add('fe-recipe-search-results');
    grid.setAttribute('data-last-page', '1');
    grid.innerHTML = entries.length
      ? entries.map(cardHtml).join('')
      : '<div class="fe-recipe-search-empty"><p>No ' +
        escapeHtml(cfg.emptyNoun) +
        ' to show.</p></div>';
    markSortReady();
  }

  function browseUrl() {
    var url = new URL(cfg.blogUrl, window.location.origin);
    writeSortParam(url, getSort());
    return url.pathname + queryString(url);
  }

  function renderResults(query) {
    var grid = document.getElementById(cfg.gridId);
    var status = document.getElementById(cfg.statusId);
    var input = document.getElementById(cfg.inputId);
    if (!grid) return;

    var q = normalize(query);
    if (input && document.activeElement !== input) {
      input.value = query;
    }

    if (!q) {
      setSearchMode(false);
      if (status) status.hidden = true;
      applyStandaloneSort();
      return;
    }

    setSearchMode(true);
    cacheGrid(grid);

    var entries = sortEntries(
      getEntries().filter(function (entry) {
        return matches(entry, q);
      }),
      getSort()
    );

    grid.classList.add('fe-recipe-search-results');
    grid.setAttribute('data-last-page', '1');

    if (entries.length === 0) {
      grid.innerHTML =
        '<div class="fe-recipe-search-empty">' +
        '<p>No ' +
        escapeHtml(cfg.emptyNoun) +
        ' matched “' +
        escapeHtml(query) +
        '”.</p>' +
        '<p><a href="' +
        escapeHtml(browseUrl()) +
        '">' +
        escapeHtml(cfg.browseLabel) +
        '</a></p>' +
        '</div>';
    } else {
      grid.innerHTML = entries.map(cardHtml).join('');
    }

    if (status) {
      status.hidden = false;
      var label = status.querySelector('[data-fe-search-term]');
      if (label) label.textContent = query;
    }

    try {
      var url = new URL(window.location.href);
      url.pathname = cfg.blogUrl;
      url.searchParams.set('q', query);
      writeSortParam(url, getSort());
      window.history.replaceState({}, '', url.pathname + queryString(url));
    } catch (e) {}

    markSortReady();
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    var form =
      document.querySelector('[data-fe-blog-search]') ||
      document.getElementById('fe-recipe-search-form');
    if (!form) return;

    cfg = readConfig(form);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = document.getElementById(cfg.inputId);
      var query = input ? input.value.trim() : '';
      if (!query) {
        window.location.href = browseUrl();
        return;
      }
      renderResults(query);
      var grid = document.getElementById(cfg.gridId);
      if (grid) {
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    var clearLink = form.querySelector('[data-fe-search-clear]');
    if (clearLink) {
      clearLink.addEventListener('click', function (event) {
        event.preventDefault();
        window.location.href = browseUrl();
      });
    }

    var sortSelect = document.querySelector('[data-fe-recipe-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var sort = sortSelect.value;
        setSortUrl(sort);
        var query = getQuery();
        if (query) {
          renderResults(query);
        } else {
          applyStandaloneSort();
        }
      });
    }

    var initial = getQuery();
    if (initial) {
      renderResults(initial);
    } else {
      applyStandaloneSort();
    }
  });
})();
